import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { statusIndicatorClassName } from '../../label.utils';
import type { StatusLabelProps } from '../../label.utils';
import PlumaBox from '../../../box/ember/index';
export interface StatusIndicatorSignature {
    Element: HTMLSpanElement;
    Args: {
        color: StatusLabelProps['color'];
    };
}
export default class StatusIndicator extends Component<StatusIndicatorSignature> {
    get className() {
        const { color: color1 } = this.args;
        return statusIndicatorClassName({
            color: color1
        });
    }
    static{
        template(`<PlumaBox @as="span" class={{this.className}} />`, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
